import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import benefitsBackground from "Images/profile/benefits-background-profile.png";
import styles from "./style.module.css";
/*
 * Benefit Item Component
 */
const BenefitItem = ({ description, name }) => (_jsxs("div", { className: styles.benefit_item, children: [_jsx("div", { className: styles.benefit_header, children: "Benefits" }), _jsx("img", { className: styles.benefit_item_img, src: benefitsBackground, alt: "" }), _jsxs("span", { className: styles.benefit_item_text, children: [_jsxs("b", { children: [name, " "] }), description] })] }));
export default BenefitItem;
